import { useTranslation } from 'react-i18next';

import { WebLink, WebLinkProps } from '../WebLink';
import { withTranslation } from '../../locales/hoc';

const APPLE_EULA_URL = 'https://www.apple.com/legal/internet-services/itunes/dev/stdeula/';

const TermsOfUseLinkBase = ({ children, ...textProps }: Props) => {
	const { t } = useTranslation();

	return (
		<WebLink title={t('legal.terms-of-use')} url={APPLE_EULA_URL} {...textProps}>
			{children || t('legal.terms-of-use')}
		</WebLink>
	);
};

type Props = Omit<WebLinkProps, 'title' | 'url'>;

export const TermsOfUseLink = withTranslation(TermsOfUseLinkBase);
